module.exports = __webpack_public_path__ + "media/images/elements/Elemntas_1-533641966d816089b3135311318af8f9.svg";